import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/tainaravictory.svg";

const TainaraVictoryIcon = () => {
  return <YourSvg />;
};

export default TainaraVictoryIcon;